import { createAction, createActionGroup, props } from "@ngrx/store";
import { LeadSummary } from "src/app/core/models/lead/lead-summary.model";
import { Lead } from "src/app/core/models/lead/lead.model";
import { AgentQualificationOutcomes } from "./models/agent-qualification-outcome.type";

export const AgentAction = createActionGroup({
    source: 'Agent',
    events: {
        'open lead info sidenav content': (lead: LeadSummary) => ({ lead }),
        'accept offer': (leadId: number | string) => ({ leadId }),
        'refuse offer': (leadId: number | string) => ({ leadId }),
        'qualify lead': (qualificationRequest: [number | string, AgentQualificationOutcomes]) => ({ qualificationRequest })
    }
});


